import { useOidcAccessToken } from "@axa-fr/react-oidc";
import { useQuery } from "graphql-hooks";
import * as React from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { Loading } from '../Shared/Loading';
import { MetaTags } from "../Shared/MetaTags";
import { NavigationCardSet } from '../Shared/NavigationCards/NavigationCardSet';
import Helper from '../../utilities/helper';
import { ACCESS_VALUES, PageNames } from '../../utilities/constValues';
import { PermissionsGate } from '../../utilities/PermissionsGate';
import { PermissionsRequired } from '../Shared/PermissionsRequired';
import { InstantEstimates } from '../Shared/InstantEstimates';
import { Testimonial } from './Testimonial';
import { WhySwitch } from './WhySwitch';
import { useAPIErrorContext } from '../../contexts/apiErrorContext'
import { ErrorBanner } from '../Shared/ErrorBanner';
import { useEffect } from "react";
import { ErrorPage } from "../Shared/ErrorPage";
import { Hero } from "../Shared/Hero";

const CMS_QUERY = `query dataQuery {
    pageData: pageHomePage {
        fieldHeroStatement
        fieldHeroTitle
        fieldComparisonJson
        fieldCostComparisonContent
        fieldDisplayTestimonialSection
        fieldCardNavigationSectionTitle
        fieldNavigationCards {
            id
            fieldCardTitle
            fieldCardLink
            fieldCardContent
            fieldCardImage {
                alt
                url
                title
            }
        }
        seo: _seoMetaTags {
            attributes
            content
            tag
        }
    }
}`;

export const Home = () => {
    const { loading, error, data } = useQuery(CMS_QUERY);
    const { accessTokenPayload } = useOidcAccessToken();
    const location = useLocation();
    const { addError, clearError, trackError } = useAPIErrorContext();
    const navigate = useNavigate();
    const { errorParam } = useParams();
    useEffect(() => {
        if (errorParam) {
            if (errorParam === '403') {
                addError('403', 'User does not have sufficient permissions.' );
            }
            if (errorParam === '404') {
                addError('404', 'Page Not Found');
            }
            if (errorParam === '401') {
                addError('401', 'User is not authorized to login to this application.');
            }
            //Refresh/Reload pages causes error banner, index.js will capture and pass a string to force navigation to home page
            if (errorParam !== '' && isNaN(Number(errorParam.toString()))) {
                navigate('/');
            }
        }
    }, []);
 
    useEffect(() => {       
        const previousPage = Helper.getPagePath();
        Helper.setPagePath(location.pathname);

        const signedIn = sessionStorage.getItem('signedIn');
        const signedOut = sessionStorage.getItem('signedOut');

        if (signedOut === 'true') {
            sessionStorage.removeItem('signedOut');
        }

        const sub = accessTokenPayload?.sub;
        const lowercaseNonSecureRoutes = Helper.getNonSecureRoutes();
        if (signedIn === 'true' && sub === undefined) {
            Helper.setPagePath(location.pathname);   
        }
        else if (signedOut === 'true' && previousPage != null && lowercaseNonSecureRoutes.indexOf(previousPage.toLowerCase()) > -1 ) {
            window.location.href = window.location.origin + previousPage;
        }

    }, [location]);

    if (!error && !loading) {
        return (
            <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={<PermissionsRequired showParticipantMsg={true} />} pageName={PageNames.Home}>
            <div className="homepage">
                <Hero pageTitle={data.pageData.fieldHeroTitle} pageStatement={data.pageData.fieldHeroStatement} />
                <ErrorBanner key="homepage" errorCode={errorParam} />
                <WhySwitch />
                <InstantEstimates/>
                {data.pageData.fieldDisplayTestimonialSection && <Testimonial />}
                <NavigationCardSet PageData={data.pageData} />
                {/* set meta tags */}
                <MetaTags seoData={data.pageData.seo}/>
            </div>
            </PermissionsGate>
        );
    }
    else if (!error) {
        return (<Loading showContent={true} includeHero={true} />);
    }
    else {
        trackError("Dato error", JSON.stringify(error));
        return (<ErrorPage showContactForm={true} includeHero={true} />);
    }
};
